
<span class="loader" 
[style.--scale-loader]=" width / 50"
[style.--width1]=" width +'px'"
[style.--loaderThickness]=" thickness + 'px'"
[style.--primaryColor]="primaryColor"
[style.--secondaryColor]="secondaryColor"></span>